module.exports = __webpack_public_path__ + "img/jywh-active.196d33c3.svg";